const palette = {
  primary: {
    main: "#8BA889",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#4B5846",
    contrastText: "#FFFFFF",
  },
  text: {
    primary: "#000000",
  },
  success: {
    main: "#0E912C",
  },
  common: {
    black: "#000000",
    white: "#FFFFFF",
  },
};

export default palette;
